import { Result } from '@puzzlemania/shared';
import { DAILY_REWARD_CYCLE_LENGTH, DAILY_REWARD_DEFAULTS, STREAK_MULTIPLIER_INCREMENT, STREAK_MULTIPLIER_MAX, getDayCoinsKey, getDayGemsKey, } from './daily-reward-constants';
function utcDateString(ts) {
    return new Date(ts).toISOString().slice(0, 10);
}
export class DailyRewardService {
    constructor(_clock, _wallet, _rc, _saveModule) {
        this._clock = _clock;
        this._wallet = _wallet;
        this._rc = _rc;
        this._saveModule = _saveModule;
        const saved = _saveModule.load();
        this._state = saved ?? { lastClaimDate: null, dayCounter: 1, streakCount: 0, version: 1 };
    }
    canClaim() {
        return this._state.lastClaimDate !== utcDateString(this._clock.now());
    }
    getCurrentDay() {
        return this._state.dayCounter;
    }
    getStreakCount() {
        return this._state.streakCount;
    }
    getStreakMultiplier() {
        return Math.min(1.0 + STREAK_MULTIPLIER_INCREMENT * this._state.streakCount, STREAK_MULTIPLIER_MAX);
    }
    /** Returns the UTC timestamp of the next midnight (00:00:00Z of the following UTC day). */
    getNextClaimTime() {
        const todayStr = utcDateString(this._clock.now());
        return new Date(todayStr + 'T00:00:00Z').getTime() + 86400000;
    }
    claim() {
        const today = utcDateString(this._clock.now());
        if (this._state.lastClaimDate === today) {
            return Result.err('already_claimed');
        }
        // Break streak if a day was skipped
        if (this._state.lastClaimDate !== null) {
            const yesterday = utcDateString(this._clock.now() - 86400000);
            if (this._state.lastClaimDate !== yesterday) {
                this._state = { ...this._state, streakCount: 0, dayCounter: 1 };
            }
        }
        const day = this._state.dayCounter;
        const defaults = DAILY_REWARD_DEFAULTS[day] ?? { coins: 100, gems: 0 };
        const baseCoins = this._rc.get(getDayCoinsKey(day), defaults.coins);
        const baseGems = this._rc.get(getDayGemsKey(day), defaults.gems);
        const coins = Math.floor(baseCoins * this.getStreakMultiplier());
        const gems = baseGems;
        this._wallet.credit('coins', coins, 'daily_reward_claim');
        if (gems > 0) {
            this._wallet.credit('gems', gems, 'daily_reward_claim');
        }
        let { dayCounter, streakCount } = this._state;
        if (dayCounter >= DAILY_REWARD_CYCLE_LENGTH) {
            streakCount += 1;
            dayCounter = 1;
        }
        else {
            dayCounter += 1;
        }
        this._state = { lastClaimDate: today, dayCounter, streakCount, version: 1 };
        this._saveModule.save(this._state);
        return Result.ok({ coins, gems });
    }
}
